import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";

import { GET_TOKEN, ARRAY_EMPTY, OBJECT_EMPTY, GENERATE_PRODUCT_NAME } from "../../../helpers";
import { API_URL, GET_VAT_HISTORY, GET_VAT_HISTORY_NAME, GET_VAT_HISTORY_COUNTRIES, CONTINENTS } from "../../../constants";

import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { SmallSpinner } from "../../dashboard/partials/SmallSpinner";
import { SelectInput } from "../../Global/SelectInput/SelectInput";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { Input } from "../../Global/Input/Input";

import "./HistoricalVatRates.css";

const regionsList = [
  {
    label: "European Union",
    value: "EUR",
  },
  {
    label: "Canada",
    value: "CA",
  },
  {
    label: "Rest of world",
    value: "REST",
  },
  {
    label: "USA",
    value: "US",
  },
]

export const HistoricalVatRates = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [vatRatesLoaded, setVatRatesLoaded] = useState(false);
  const [submitInProgress, setSubmitInProgress] = useState(false);

  const [continent, setContinent] = useState('');

  const [countriesList, setCountriesList] = useState([]);
  const [acountriesList, setaCountriesList] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedRegion, setSelectedRegion] = useState(regionsList[0]);

  const [historicalVatItem, setHistoricalVatItem] = useState({});
  const [historicalVatRates, setHistoricalVatRates] = useState([]);

  const [error, setError] = useState([])


  const fetchCountryItem = () => {
    setVatRatesLoaded(false)

    getCurrentContinent(selectedCountry)
      .then((resContinent) => {
        fetch(API_URL + GET_VAT_HISTORY + `${resContinent + '/' +  selectedCountry.value}`, {
          method: "get",
          headers: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + GET_TOKEN(),
          }),
        })
        .then(res => res.json())
        .then((res) => {
          setHistoricalVatItem(res)
          setHistoricalVatRates(res.rates)
    
          setVatRatesLoaded(true)
        })
        .catch(() => {
          setDataLoaded(true)
        })
      })
  }

  const submitNewValues = () => {
    setError([])

    const submitTaxName = () => {
      console.log('tax name submit', JSON.stringify([{
        tax_name: historicalVatItem.tax_name,
        country_id: historicalVatItem.country.id
      }]))

      fetch(API_URL + GET_VAT_HISTORY_NAME + continent, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
        body: JSON.stringify([{
          tax_name: historicalVatItem.tax_name,
          country_id: historicalVatItem.country.id
        }]),
      })
      .then((response) => response.json())
      .then((response) => {
  
        response.error 
          ? console.error('klaidele', response.error)
          : console.log('saved')
  
        setSubmitInProgress(false)
      })
      .catch(error => {
        setSubmitInProgress(false)
      });
    }

    const submitBody = JSON.stringify(historicalVatRates)

    console.log(submitBody)

    fetch(API_URL + GET_VAT_HISTORY + `${continent + '/' +  selectedCountry.value}` , {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: submitBody,
    })
    .then(response => {
      const adaptedResponse = response.json()

      adaptedResponse.then(res => response.status == 400 && setError(res))
      if (response.status != 400) {
        fetchCountryItem()
        submitTaxName()
      } else {
        setSubmitInProgress(false)

      }
      return adaptedResponse
    })
    .catch(error => {
      console.log(error)
      setSubmitInProgress(false)
    });
  }

  // Helpers
  const insert = (arr, index, ...newItems) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

  const continentLabelToCode = (label) => {
    switch (label) {
      case 'European Union': {
        setContinent('EUR');
        return 'EUR'
      }

      case 'Rest of World': {
        setContinent('REST');
        return 'REST'
      }

      case 'Canada': {
        setContinent('CA');
        return 'CA'
      }

      case 'United States': {
        setContinent('US');
        return 'US'
      }

      default:
        setContinent('');
        return ''
    }
  }

  const getCurrentContinent = () => {
    return new Promise(resolve => {    
      countriesList.map((continentObj) => 
        Object.entries(continentObj.options).map(([, countryMapValue]) => {
          if (countryMapValue === selectedCountry) {
            return resolve(continentLabelToCode(continentObj.label))
          }
        })
      );
    });
  };

  const setItemForHook = (value, rowIndex, itemName) => {
    console.log(rowIndex+" "+value);

    const newRatesArray = historicalVatRates
    newRatesArray[rowIndex] = {
      ...newRatesArray[rowIndex],
      [itemName]: value
    }
    setHistoricalVatRates([
      ...newRatesArray,
    ]);
  }

  const formatUTC = (dateInt, addOffset = false) => {
    let date = (!dateInt || dateInt.length < 1) ? new Date : new Date(dateInt);
    if (typeof dateInt === "string") {
        return date;
    } else {
        const offset = addOffset ? date.getTimezoneOffset() : -(date.getTimezoneOffset());
        const offsetDate = new Date();
        offsetDate.setTime(date.getTime() + offset * 60000)
        return offsetDate;
    }
}

  // Components:
  const EuTable = () => {
    const generateDefaultBody = (productCode = 1001, productName) => {

      return {
        to: null,
        from: null, 
        name: productName ?? GENERATE_PRODUCT_NAME(productCode),
        code: productCode,
        rate: '',
        newItem: true,
      }
    }

    const EuVatItemsColumns = [
      {
        Header: "Product Name",
        accessor: "name",
        className: "cell_product_name",
        Cell: (cell) => 
          <div className="cell_product_name__value">
            {cell.value}

            {cell.row.original.newItem 
              && (
                <button 
                  onClick={() => {
                    const newArray = historicalVatRates
                          newArray.splice(cell.row.index, 1)

                    setHistoricalVatRates([
                      ...newArray
                    ])
                  }}
                >
                  Cancel
                </button>
              )
            }

            {cell.row.original.last && (
              <button 
                disabled={cell.rows[cell.row.index + 1]?.original?.newItem}
                onClick={() => {
                  const newArray = historicalVatRates

                  setHistoricalVatRates([
                    ...insert(
                      newArray,
                      cell.row.index + 1,
                      generateDefaultBody(cell.row.original.code, cell.row.original.name)
                    )
                  ])
                }}
              >
                Add
              </button>
            )}
          </div>
      },
      {
        Header: "Product Code",
        accessor: "code",
        className: "cell_product_name",
      },
      {
        Header: "Active from",
        accessor: "from",
        className: "cell_product_name",
        Cell: (cell) => {
          return (
            <div className="input-wrapper datefrom">
              <DatePicker
                showDisabledMonthNavigation
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                selected={Date.parse(cell.value)}
                onChange={(newDate) => setItemForHook(formatUTC(newDate), cell.row.index, 'from')}
                name="from"
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </div>
          )
        },
      },
      {
        Header: "Active to",
        accessor: "to",
        className: "cell_product_name",
        Cell: (cell) => {
          return (
            <div className="input-wrapper dateto">
              <DatePicker
                showDisabledMonthNavigation
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                selected={Date.parse(cell.value)}
                onChange={(newDate) => {
                  setItemForHook(formatUTC(newDate), cell.row.index, 'to')
                }}
                name="to"
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </div>
          )
        },
      },
      {
        Header: "Rate",
        accessor: "rate",
        className: "cell_product_name",
        Cell: (cell) => {
          return (
            <div className="input-wrapper dateto">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'rate')
                }}
              />
            </div>
          )
        },
      },

    ]

    return <div className="HistoricalVatRatesTable EuTable">
      <div className="VatItemTitle flex-align-center">
        {historicalVatItem?.country?.img && <img src={historicalVatItem.country.img} alt="flag" className="flag-icon-img"/>}
        {historicalVatItem?.country?.name && <p>{historicalVatItem.country.name}</p>}

          <Input 
            defaultValue={historicalVatItem.tax_name || ''}
            inputBlurHandler={(value) => {
              setHistoricalVatItem({
                ...historicalVatItem,
                tax_name: value
              })
            }}
          />

          {!ARRAY_EMPTY(error) && <>
            <ul className="HistoricalVatRatesTable__error_list">
              {error.map((item, index) => 
                <li key={'error_' + index}>
                  {item.error}
                </li>
              )}
            </ul>
          </>}
      </div>
    
      {vatRatesLoaded && 
        <ReactTable className="HistoricalVatRatesTable__table" columns={EuVatItemsColumns} data={historicalVatRates} />
      }
    </div>
  }

  const CaTable = () => {
    const CaVatItemsColumns = [
      {
        Header: "Active from",
        accessor: "from",
        className: "cell_product_name",
        Cell: (cell) => {
          return (
            <div className="input-wrapper datefrom">
              <DatePicker
                showDisabledMonthNavigation
                //minDate={new Date('2020-01-01')}
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                selected={Date.parse(cell.value)}
                onChange={(newDate) => {
                  setItemForHook(formatUTC(newDate), cell.row.index, 'from')
                }}
                name="from"
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </div>
          )
        },
      },
      {
        Header: "Active to",
        accessor: "to",
        className: "cell_product_name",
        Cell: (cell) => {
          return (
            <div className="input-wrapper dateto">
              <DatePicker
                showDisabledMonthNavigation
                //minDate={new Date('2020-01-01')}
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                selected={Date.parse(cell.value)}
                onChange={(newDate) => {
                  setItemForHook(formatUTC(newDate), cell.row.index, 'to')
                }}
                name="to"
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </div>
          )
        },
      },
      {
        Header: "Federal",
        accessor: "federal",
        className: "cell_federal",
        Cell: (cell) => {
          return (
            <div className="input-wrapper dateto">
              <Input 
                defaultValue={cell.row.original.federal}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'federal')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "State",
        accessor: "state_province",
        className: "cell_state",
        Cell: (cell) => {
          return (
            <div className="input-wrapper">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'state_province')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Combined",
        accessor: "combined",
        className: "cell_state",
        Cell: (cell) => {
          return parseFloat(cell.row.original.state_province ?? 0) + parseFloat(cell.row.original.federal ?? 0)
        },
      },
    ]

    return <div className="HistoricalVatRatesTable EuTable">
      <div className="VatItemTitle VatItemTitle flex-align-center">
        {historicalVatItem?.country?.img && <img src={historicalVatItem.country.img} alt="flag" className="flag-icon-img"/>}
        {historicalVatItem?.country?.name && <p>{historicalVatItem.country.name}</p>}

          <Input 
            defaultValue={historicalVatItem.tax_name || ''}
            inputBlurHandler={(value) => {
              setHistoricalVatItem({
                ...historicalVatItem,
                tax_name: value
              })
            }}
          />
        
        {/* EU HAS NO ADD BUTTON NEXT TO TITLE  */}
        <button
          className="button_to_link"
          onClick={() => {
            setHistoricalVatRates([
              ...historicalVatRates,
              {
                one: null,
                from: null,
                to: null,
                newItem: true,
              }
            ])
          }}
        >
          Add
        </button> 
        
        {!ARRAY_EMPTY(error) && <>
          <ul className="HistoricalVatRatesTable__error_list">
            {error.map((item, index) => 
              <li key={'error_' + index}>
                {item.error}
              </li>
            )}
          </ul>
        </>}
      </div>
    
      {!ARRAY_EMPTY(historicalVatRates) && 
        <ReactTable className="HistoricalVatRatesTable__table" columns={CaVatItemsColumns} data={historicalVatRates} />
      }
    </div>
  }

  const UsaTable = () => {
    // ZIP code	
    // Tax region name	
    // State rate	
    // Country rate	
    // City rate	
    // Special rate	
    // Combined

    const UsaVatItemsColumns = [
      {
        Header: "ZIP code",
        accessor: "postal_code",
      },
      {
        Header: "Tax region name",
        accessor: "tax_region_name",
      },
      {
        Header: "State rate",
        accessor: "state_rate",
        className: "cell_federal",
        Cell: (cell) => {
          return (
            <div className="input-wrapper">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'state_rate')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Country rate",
        accessor: "country_rate",
        Cell: (cell) => {
          return (
            <div className="input-wrapper">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'country_rate')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "City rate",
        accessor: "city_rate",
        Cell: (cell) => {
          return (
            <div className="input-wrapper">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'city_rate')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Special rate",
        accessor: "special_rate",
        Cell: (cell) => {
          return (
            <div className="input-wrapper">
              <Input 
                defaultValue={cell.value}
                inputBlurHandler={(value) => {
                  setItemForHook(value, cell.row.index, 'special_rate')
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Combined",
        accessor: "combined",
        Cell: (cell) => {
          console.log(cell.row.original)
          return (
            ( 
              // parseFloat(cell.row.original.state_rate ?? 0) + 
              // parseFloat(cell.row.original.country_rate ?? 0) +
              // parseFloat(cell.row.original.city_rate ?? 0) +
              parseFloat(cell.row.original.combined ?? 0)
            ) + ' %'
          )
        },
      },
    ]

    return <div className="HistoricalVatRatesTable EuTable">
      <div className="VatItemTitle VatItemTitle flex-align-center">
        {historicalVatItem?.country?.img && <img src={historicalVatItem.country.img} alt="flag" className="flag-icon-img"/>}
        {historicalVatItem?.country?.name && <p>{historicalVatItem.country.name}</p>}

          {/* <Input 
            defaultValue={historicalVatItem.tax_name || ''}
            inputBlurHandler={(value) => {
              setHistoricalVatItem({
                ...historicalVatItem,
                tax_name: value
              })
            }}
          /> */}
        
        {!ARRAY_EMPTY(error) && <>
          <ul className="HistoricalVatRatesTable__error_list">
            {error.map((item, index) => 
              <li key={'error_' + index}>
                {item.error}
              </li>
            )}
          </ul>
        </>}
      </div>
    
      {!ARRAY_EMPTY(historicalVatRates) && 
        <ReactTable className="HistoricalVatRatesTable__table" columns={UsaVatItemsColumns} data={historicalVatRates} />
      }
    </div>
  }

  const HistoricalVatItemConstructor = () => {
    switch (continent) {
      case 'EUR': {
        return <EuTable />
      }

      case 'REST': {
        return <EuTable />
      }

      case 'CA': {
        return <CaTable />
      }

      case 'US': {
        return <UsaTable />
      }
    
      default:
        return <>Other Table</>
    }
  }

  // Effects
  useEffect(() => {
    setSelectedRegion(regionsList[0])
  }, [])

  useEffect(() => {
    if (!ARRAY_EMPTY(countriesList)) {
      const currentCountries = countriesList.filter(region => region?.regionValue === selectedRegion.value)
      setSelectedCountry(currentCountries[0]?.options[0] ?? {})
    }
  }, [selectedRegion])

  useEffect(() => {
    fetch(API_URL + GET_VAT_HISTORY_COUNTRIES, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then(res => res.json())
      .then((res) => {
        let byRegion = {}
        let regionsArray = []

        res.map((item) => {
          const generateRegions = () => {
            if (item.region) {
              byRegion[item.region] === undefined && (
                byRegion = {
                  ...byRegion,
                  [item.region]: {
                    label: (CONTINENTS[item.region] || item.region),
                    regionValue: item.region,
                    options: [],
                  }
                }
              )
            } 
  
            else if (item.region === null) {
              byRegion['REST'] === undefined && (
                byRegion = {
                  ...byRegion,
                  'REST': {
                    label: (CONTINENTS['REST']),
                    regionValue: 'REST',
                    options: [],
                  }
                }
              )
            }
          } 

          generateRegions()

          !!item.region
            ? (
                byRegion[item.region].options = [
                  ...byRegion[item.region].options,
                  {
                    label: item.name,
                    value: item.id 
                  }
                ]
            )
            : (
                byRegion['REST'].options = [
                  ...byRegion['REST'].options,
                  {
                    label: item.name,
                    value: item.id 
                  }
                ]
            )
        })

        Object.entries(byRegion).map(
          ([, itemValue]) => {
            return regionsArray = [
              ...regionsArray,
              itemValue
            ]
          }
        )

        const currentCountries = regionsArray.filter(region => region.regionValue === selectedRegion.value)

        setCountriesList(regionsArray)
        continentLabelToCode(regionsArray[0].label)
        setSelectedCountry(currentCountries[0].options[0])
        setDataLoaded(true)
      })
      .catch((err) => {
        console.log('error', err)
      })
  }, [])

  useEffect(() => {
    setError([])
    fetchCountryItem()
  }, [selectedCountry])

  return <div className="HistoricalVatRates">
    <div className="HistoricalVatRates__top-title Dashboard__content__top-row flex">
      
      <h2>Historical VAT rates</h2>
      
      <SelectInput 
        className="continent"
        value={selectedRegion}
        selectValues={regionsList}
        inputValueHandler={(val) => setSelectedRegion(val)}
      />

      <SelectInput 
        value={selectedCountry}
        selectValues={countriesList.filter(region => region.regionValue === selectedRegion.value)}
        inputValueHandler={(val) => setSelectedCountry(val)}
      />

      <div className="submit_wrapper flex-align-center">
        {submitInProgress && <SmallSpinner />}

        <button
          className="default_button"
          onClick={() => {
            setSubmitInProgress(true)
            submitNewValues()
          }}
        >
          save changes
        </button>
      </div>

    </div>

    {vatRatesLoaded
      ? !OBJECT_EMPTY(historicalVatItem) ? HistoricalVatItemConstructor() : 'No Data'
      : <LoadingSpinner />
    }
  </div>
}